import menu from '@constants/menu';
import menu_crm from '@constants/menu-crm';
import isCRMUser from '@util/isCRMUser';

function getConfig (cPath, cMenus) {
  const menu = cMenus.filter((m) => {
    return m.path === cPath;
  });
  return menu[0];
};

export default (path) => {
  const ret = [];
  const menus = isCRMUser() ? menu_crm : menu;
  const paths = path.substring(1).split('/');
  let parentConfig = null;
  let subConfig = null;

  if (paths.length === 1) {
    parentConfig = getConfig('/' + paths[0], menus);
    subConfig = parentConfig;
  } else {
    parentConfig = getConfig(paths[0], menus);
    subConfig = getConfig(`/${paths[0]}/${paths[1]}`, parentConfig ? parentConfig.children : []);
  }
  ret.push(parentConfig);
  ret.push(subConfig);
  return ret;
};



// WEBPACK FOOTER //
// ./src/components/util/getRouterConf.js